import { InputAdornment, TextField } from "@mui/material";
import { SearchIcon } from "../../../assets/icons/MUI/ChatIcons";
import { useTranslation } from "react-i18next";

const SearchBar = ({
  searchValue,
  setSearchValue,
}: {
  searchValue: string;
  setSearchValue: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  return (
    <TextField
      placeholder={t("pages.chat.search")}
      variant="outlined"
      value={searchValue}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchValue(event.target.value);
      }}
      InputLabelProps={{
        shrink: false,
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon style={{ fill: "none" }} />
          </InputAdornment>
        ),
      }}
      sx={{
        margin: "0 15px 17px",
        "& .MuiInputBase-root": {
          columnGap: "10px",
        },
      }}
    />
  );
};

export default SearchBar;
